import React from 'react';

import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import { PlanUnitLink } from '../types';

import { useGetEntities } from './utils/useGetEntities';

import { Skeleton } from '@mui/material';

import { ControlledAutoComplete } from 'components/shared';

interface Props {
  mode?: PlanUnitLink;
  name?: string;
}

export const EntityDropDown: React.FC<Props> = ({ mode, name }) => {
  const { isFetching: isFetchingEntities, data: entities } =
    useGetEntities(mode);
  const { control } = useFormContext();

  const modeLabel = t(mode ?? '');
  const label = `${modeLabel?.[0]?.toUpperCase()}${modeLabel?.slice(1)}`;

  return isFetchingEntities ? (
    <Skeleton />
  ) : (
    <ControlledAutoComplete
      fullWidth
      idProperty="value"
      optionLabelProp="label"
      variant="outlined"
      label={t(label ?? '')}
      name={name || 'entity'}
      options={entities ?? []}
      control={control}
    />
  );
};
